import { render, staticRenderFns } from "./AboutUsEdit.vue?vue&type=template&id=b8b586da&scoped=true"
import script from "./AboutUsEdit.vue?vue&type=script&lang=js"
export * from "./AboutUsEdit.vue?vue&type=script&lang=js"
import style0 from "./AboutUsEdit.vue?vue&type=style&index=0&id=b8b586da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b586da",
  null
  
)

export default component.exports